module.exports = __webpack_public_path__ + "static/media/selected_bookmark.3e62fd98.svg";